import React from "react";
import { connect } from "react-redux";
import { Maybe } from "true-myth";
import { submitCreditCardPayment, setCreditCardRequestStatus, } from "actions/mobile_pay";
import ViewStateManager from "components/mobile_pay/view_state_manager";
import ErrorPage from "components/mobile_pay/views/error_page";
import Loader from "components/loader";
import { RequestStatus } from "types/requests";
import { combineRemoteData } from "helpers/mobile_pay";
function MobilePayContainer(props) {
    var checkInfoRequest = props.checkInfoRequest, merchantInfoRequest = props.merchantInfoRequest, processedPaymentInfoRequest = props.processedPaymentInfoRequest, creditCardRequestStatus = props.creditCardRequestStatus, onSubmitCreditCardPayment = props.onSubmitCreditCardPayment, onSetCreditCardRequestStatus = props.onSetCreditCardRequestStatus;
    var combinedRemoteData = combineRemoteData(checkInfoRequest, merchantInfoRequest);
    switch (combinedRemoteData.type) {
        case RequestStatus.FAILURE: {
            return (React.createElement(ErrorPage, { merchantInfo: Maybe.of(merchantInfoRequest.type === RequestStatus.SUCCESS
                    ? merchantInfoRequest.result
                    : null) }));
        }
        case RequestStatus.SUCCESS: {
            return (React.createElement(ViewStateManager, { checkInfo: combinedRemoteData.result.first, merchantInfo: combinedRemoteData.result.second, processedPaymentInfoRequest: processedPaymentInfoRequest, creditCardRequestStatus: creditCardRequestStatus, submitCreditCardPayment: onSubmitCreditCardPayment, setCreditCardRequestStatus: onSetCreditCardRequestStatus }));
        }
        default: {
            return (React.createElement("div", { className: "app" },
                React.createElement(Loader, null)));
        }
    }
}
function mapStateToProps(state) {
    return {
        merchantInfoRequest: state.merchantInfoRequest,
        checkInfoRequest: state.checkInfoRequest,
        processedPaymentInfoRequest: state.processedPaymentInfoRequest,
        creditCardRequestStatus: state.creditCardRequestStatus,
    };
}
var mapDispatchToProps = {
    onSubmitCreditCardPayment: submitCreditCardPayment,
    onSetCreditCardRequestStatus: setCreditCardRequestStatus,
};
var ConnectedMobilePayContainer = connect(mapStateToProps, mapDispatchToProps)(MobilePayContainer);
export default ConnectedMobilePayContainer;
